import { ASSETS } from '@/constants';

export default function videoPlayer() {
  return {
    _id: false,
    type: 'droplet.videoPlayer',
    videoFile: `${process.env.S3_ASSETS_URL}multi-media/love-coding.mp4`,
    baseColor: 'default',
    mediaQueries: [
      {
        selector: '.drzVideo-progress',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    playsinline: false,
    autoplay: false,
    loop: false,
    muted: false,
    hideControls: false,
    hideProgress: false,
    hasLink: false,
    pageLink: false,
    customLink: false,
    newWindow: false,
    enableThumb: false,
    thumbnail: `${ASSETS}mock-images/default-images/video-droplet-thumb.svg`,
    ref: null,
    latestDynamic: false,
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/video-player/droplet.schema.js